import React from 'react';

const IgnoreBreadcrumbContext = React.createContext<boolean>(false);

export default IgnoreBreadcrumbContext;
